const { PUBLIC_URL } = process.env;

export const basePath: string = PUBLIC_URL || '';
